<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <h1 class="title has-text-centered is-spaced">
      <go-to-dashboard-button />

      {{ $t("settlements.title") }}
      <span v-show="!c1 && !c2">&nbsp;</span>

      <br v-show="c1" />

      <button
        class="button"
        @click="$emit('get-settlements')"
        :style="c1 ? 'margin-top: 1rem;' : ''"
      >
        <b-icon icon="sync-alt"></b-icon>
      </button>

      <div v-if="permissions.downloadSettlementsReport" class="inline">
        &nbsp;
        <button
          class="button"
          @click="$emit('download-settlement-report')"
          :style="c1 ? 'margin-top: 1rem;' : ''"
        >
          <b-icon icon="save"></b-icon>
        </button>
      </div>

      <br v-show="c2" />

      <span v-show="!c2">&nbsp;&nbsp;&nbsp;</span>
      <span
        :style="
          c1
            ? 'position: relative; top: -0.1rem;'
            : 'position: relative; top: -1.1rem;'
        "
      >
        <b-datepicker
          style="width: 120px; display: inline-block;"
          :placeholder="$t('common.selectPeriod')"
          v-model="date"
          @input="$emit('update-date', date)"
          :mobile-native="false"
        ></b-datepicker>
      </span>

      <b-field style="margin-top: 10px">
        <b-autocomplete
          :placeholder="$t('common.store')"
          :open-on-focus="true"
          v-model="ms"
          :data="filteredData"
          @select="option => (selected = option)"
          @input="updateSettlementByStore"
        ></b-autocomplete>
      </b-field>

      <hr />
    </h1>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import { responsive } from "../../mixins/responsive";
import goToDashboardButton from "../common/GoToDashboardButton";

export default {
  mixins: [common, responsive],

  components: {
    goToDashboardButton
  },

  data() {
    return {
      isLoading: false,
      date: null,
      dropdownList: [this.$t("common.allStores")],
      ms: "",
      selected: null,
      myStores: []
    };
  },

  methods: {
    updateSettlementByStore(ms) {
      const index = this.myStores.findIndex(s => {
        return ms === s.split("||")[1];
      });

      if (index > -1) {
        const storeId = this.myStores[index].split("||")[0];
        this.$emit("update-store-id", storeId);
      } else if (ms === "Todas as lojas") {
        this.$emit("update-store-id", "");
      }
    }
  },

  computed: {
    ...mapGetters(["permissions", "stores"]),

    c1() {
      return this.windowWidth < 700;
    },

    c2() {
      return this.windowWidth < 370;
    },

    filteredData() {
      return this.dropdownList.filter(option => {
        return (
          option
            .toString()
            .toLowerCase()
            .indexOf(this.ms.toLowerCase()) >= 0
        );
      });
    }
  },

  mounted() {
    this.date = new Date();

    for (let i = 0; i < this.stores.length; i++) {
      this.dropdownList.push(this.stores[i].storeInfo.name);
      this.myStores.push(
        `${this.stores[i]._id}||${this.stores[i].storeInfo.name}`
      );
    }
  }
};
</script>

<style scoped>
.inline {
  display: inline;
}
hr {
  background-color: hsl(0, 0%, 71%);
}
</style>
